<div class="container">
    <div class="d-flex justify-content-between vocher-title my-4">
        <h2 >Vouchers List</h2>
        <button data-toggle="modal" data-target="#exampleModalCenter" (click)="voucherForm.reset();isEditVoucher=false">Add voucher</button>
    </div>
    <table class="voucher-table table">
        <thead>
            <tr>
                <th> name</th>
                <th> description</th>
                <th> point</th>
                <th> code</th>
                <th> Type</th>
                <th>Active Status</th>
                <th>Redemption Count</th>
                <th> Image </th>
                <th>Action</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let item of vouchers">
                <td>
                    {{item?.voucherName}}
                </td>
                <td>
                    {{item?.voucherDescription}}
                </td>
                <td>
                    {{item?.points_required}}
                </td>
                <td>
                    {{item?.voucherCode}}
                </td>
                <td>
                    {{item?.voucherType}}
                </td>
                <td>
                    {{ item.active ? 'Active' : 'Expired' }}
                </td>
                <td (click)="onClickHistory(item)" class="redeemed-count">
                    {{item?.redemptionCount}}
                </td>
                <td>
                    <div class="vocher-img">
                        <img loading="lazy" src="{{imgurl}}{{item.voucherImage}}"
                            alt="img">
                    </div>
                </td>
                <td>
                    <div class="d-flex action-btn">
                        <button type="button">
                            <img loading="lazy" data-toggle="modal" data-target="#exampleModalCenter" (click)="onClickEdit(item)" src="../../../../assets/images/edit-icon.svg" alt="edit-icon">
                        </button>
                        <button (click)="onDeleteVoucher(item.id)" type="button" data-toggle="modal" data-target="#deleteModal">
                            <img loading="lazy" src="../../../assets/images/delete-icon.svg" alt="delete-icon">
                        </button>
                    </div>
                </td>
            </tr>
        </tbody>
    </table>
</div>

<!-- Add voucher Modal -->
<div class="modal fade" id="exampleModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered add-voucher-modal" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLongTitle">Add voucher</h5>
                <button type="button" class="close-btn" data-dismiss="modal" aria-label="Close">
                    <img loading="lazy" src="../../../assets/images/close-icons.svg" alt="img">
                </button>
            </div>
            <div class="modal-body">
                <form [formGroup]="voucherForm" >
                    <div class="row">
                      <div class="col-lg-6">
                        <div class="vocher-filed">
                          <label for="name">Name</label>
                          <input type="text" formControlName="voucherName" placeholder="Enter Voucher Name">
                          <div *ngIf="f.voucherName.errors && (f.voucherName.dirty || f.voucherName.touched)" class="text-danger">
                            <div *ngIf="f.voucherName.errors.required">Name is required</div>
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-6">
                        <div class="vocher-filed">
                          <label for="description">Description</label>
                          <input type="text" formControlName="voucherDescription" placeholder="Enter Voucher Description">
                          <div *ngIf="f.voucherDescription.errors && (f.voucherDescription.dirty || f.voucherDescription.touched)" class="text-danger">
                            <div *ngIf="f.voucherDescription.errors.required">Description is required</div>
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-6">
                        <div class="vocher-filed">
                          <label for="point">Point</label>
                          <input type="number" formControlName="points_required" placeholder="Enter Voucher Point">
                          <div *ngIf="f.points_required.errors && (f.points_required.dirty || f.points_required.touched)" class="text-danger">
                            <div *ngIf="f.points_required.errors.required">Point is required</div>
                            <div *ngIf="f.points_required.errors.pattern">Enter a valid integer value</div>
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-6">
                        <div class="vocher-filed">
                          <label for="code">Code</label>
                          <input type="text" formControlName="voucherCode" placeholder="Enter Voucher Code">
                          <div *ngIf="f.voucherCode.errors && (f.voucherCode.dirty || f.voucherCode.touched)" class="text-danger">
                            <div *ngIf="f.voucherCode.errors.required">Code is required</div>
                            <div *ngIf="f.voucherCode.errors.pattern">Enter a valid integer value</div>
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-6">
                        <div class="vocher-filed">
                          <label for="validity">Validity</label>
                          <input type="date" formControlName="voucherValidity" placeholder="Enter Voucher Validity">
                          <div *ngIf="f.voucherValidity.errors && (f.voucherValidity.dirty || f.voucherValidity.touched)" class="text-danger">
                            <div *ngIf="f.voucherValidity.errors.required">Validity is required</div>
                            <div *ngIf="f.voucherValidity.errors.pattern">Enter a valid integer value</div>
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-6">
                        <div class="vocher-filed">
                          <label for="voucherType">Voucher Type</label>
                          <select id="voucherType" formControlName="voucherType" class="form-control">
                            <option value="" disabled selected>Select Voucher Type</option>
                            <option value="Gold">Gold</option>
                            <option value="Diamond">Diamond</option>
                            <option value="Platinum">Platinum</option>
                          </select>
                          <div *ngIf="f.voucherType.errors && (f.voucherType.dirty || f.voucherType.touched)" class="text-danger">
                            <div *ngIf="f.voucherType.errors.required">Voucher type is required</div>
                          </div>
                        </div>
                      </div>
                      
                      <div class="col-lg-6">
                        <div class="vocher-filed add-img">
                            <p>Image</p>
                            <label>
                                Add Image
                                <input (change)="onFileChange($event)" type="file" />
                            </label>
                        </div>
                    </div>
                    </div>
                  </form>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                <button type="button" class="btn btn-primary" data-dismiss="modal" (click)="onSubmit()">Save</button>
            </div>
        </div>
    </div>
</div>

<!-- Delete Modal -->

<div class="modal fade" id="deleteModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered delete-modal" role="document">
        <div class="modal-content">
            <div class="modal-body">
                <p>Are you sure you want to delete this voucher? </p>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="deleteVoucher()">Delete</button>
            </div>
        </div>
    </div>
</div>

<ng-template #redeemHistoryModal let-modal >
  <div class="modal-box">
    <div class="heading-wrp">
        <h2>Redemption History</h2>
        <img loading="lazy" (click)="dismissModal()" src="../../../assets/images/close-icon.svg" alt="img">
    </div>
    <table class="voucher-table table">
        <thead>
            <tr>
                <th> Name</th>
                <th> Number</th>
                <th> Date Of redemption </th>
                
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let item of redeemHistory">
                <td>
                    {{item?.appUser?.name}}
                </td>
                <td>
                    {{item?.appUser?.phone}}
                </td>
                <td>
                    {{item?.redeemedAt*1000 | date: 'medium'}}
                </td>
            </tr>
           
        </tbody>
    </table>
  </div>
  </ng-template>